import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

import { CONTENT_TYPE } from 'src/data/contentType';
import { GENERATION_TOOL } from 'src/data/generationTool';
import Button from 'src/components/Button';
import { Popup } from 'src/components/Popup';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import FieldContentTaxonomy from './views/FieldContentTaxonomy';
import { useHandlers } from './useHandlers';
import { useViewState } from './useViewState';
import { useStyles } from './useStyles';

export const ScoringMethodPopup = ({ open, onSubmit, onApplyAll }) => {
  const styles = useStyles();

  const [isLoading, setIsLoading] = useState(false);

  const { handleConfirm, handleClose, handleChange, handleApplyAll } = useHandlers({
    onSubmit,
    onApplyAll,
    setIsLoading,
  });
  const { error, selectedTaxonomyId } = useViewState();

  return (
    <Popup
      open={open}
      classes={{
        paper: styles.paper,
      }}
      onClose={handleClose}
      isCloseHidden
    >
      <DialogTitle disableTypography>
        <CustomTypography variant={TYPOGRAPHY_VARIANT.semiBold16}>
          Select comparison data set
        </CustomTypography>
      </DialogTitle>

      <DialogContent className={styles.dialogContent}>
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.paragraph16}
        >
          Select the data set that matches best with your industry.
          <br />
          We will compare your content with content in this data set.
        </CustomTypography>
        <CustomTypography variant={TYPOGRAPHY_VARIANT.medium14}>Select data set</CustomTypography>
        <FieldContentTaxonomy
          value={selectedTaxonomyId}
          onChange={handleChange}
          error={error}
          hideLabel
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleClose}
          variant="text"
          color="primary"
          disabled={isLoading}
        >
          Cancel
        </Button>

        {onApplyAll && (
          <Button
            className={styles.buttonApplyAll}
            onClick={handleApplyAll}
            variant="contained"
            loading={isLoading}
          >
            Apply all
          </Button>
        )}

        <Button
          className={styles.buttonAction}
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          disabled={isLoading}
        >
          Apply
        </Button>
      </DialogActions>
    </Popup>
  );
};

ScoringMethodPopup.propTypes = {
  open: PropTypes.bool,
  contentType: PropTypes.oneOf(Object.values(CONTENT_TYPE)).isRequired,
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

ScoringMethodPopup.defaultProps = {
  open: false,
};
